<template>
  <div class="box6">
    <div class="three">优势三</div>
    <div class="subTitle">
      为不同年限Java工程师合理设置学习起点，查漏<br />知识点+夯实技术，从0到1构建全局架构思维
    </div>
    <div class="tit"><span>必修课</span>-快速提升架构能力</div>
    <div class="scorll-box6">
      <div class="nav-box">
        <div
          class="nav"
          v-for="(item, index) in list"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
        >
          {{ item.nav }}
        </div>
      </div>
    </div>

    <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
      <swiper-slide
        class="swiperwrap"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="content" ref="block">
          <div class="open">
            查看全部
            <img src="../../../assets/coursePage/ai/box11/open.png" alt />
          </div>
          <div class="stage">{{ item.title }}</div>
          <div class="tag">
            <img
              class="icon1"
              src="../../../assets/coursePage/cPuls/box6/icon1.png"
              alt
            />
            主要内容
          </div>

          <div
            class="subject-block ability"
            v-for="(item1, index1) in item.primaryCoverage"
            :key="index1 + 'a'"
          >
            <div class="block-title">{{ item1.itemTit }}</div>
            <p v-for="i in item1.itemArr" :key="i" class="block-p">
              <span></span>
              {{ i }}
            </p>
          </div>

          <div class="tag">
            <img
              class="icon2"
              src="../../../assets/coursePage/cPuls/box6/icon2.png"
              alt
            />
            核心能力培养
          </div>
          <div class="subject-block ability">
            <p v-for="j in item.corCompetence" :key="j">{{ j }}</p>
          </div>

          <div class="tag">
            <img
              class="icon3"
              src="../../../assets/coursePage/cPuls/box6/icon3.png"
              alt
            />
            具备市场价值
          </div>
          <div class="subject-block ability">
            <p v-for="k in item.marketValue" :key="k">{{ k }}</p>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="tit tit1"><span>Java基础</span>-查漏补缺、全局盘点</div>

    <div class="content" @click="open">
      <div class="open">
        查看全部
        <img src="../../../assets/coursePage/ai/box11/open.png" alt />
      </div>
      <div class="stage">2年~4年经验学习起点</div>
      <div class="tag">
        <img
          class="icon4"
          src="../../../assets/coursePage/cPuls/box6/icon4.png"
          alt
        />
        学习背景
      </div>

      <div class="subject-block">
        <p>
          从事Java开发2-4年，已初步学会使用项目中的Java技术栈、开发流程，了解常用中间件。这个年限的小伙伴如果要晋级架构师，要确保在开发层面对知识体系查缺补漏，达到熟练运用常见开发框架、中间件完成基本的项目搭建和开发，需要将常用的技术做一个全局的盘点，关注相互之间的联系，并学会跳出技术点本身，站在全局视角来看待其相关的整个体系。
        </p>
      </div>

      <div class="tag">
        <img
          class="icon1"
          src="../../../assets/coursePage/cPuls/box6/icon1.png"
          alt
        />
        主要内容
        <span>（部分课程穿插直播）</span>
      </div>
      <div class="subject-block ability">
        <p>1. 微服务-SpringBoot快速开发</p>
        <p>2. 开发阵营之一：Dubbo体系基础</p>
        <p>3. 分布式协调工具：Zookeeper深度剖析</p>
        <p>4. 开发阵营之二：SpringCloud体系基础</p>
        <p>5. 链路追踪工具：Skywalking真实演练</p>
        <p>6. 发布工具：携程Apollo应用发布实战</p>
        <p>7. 网络编程基础</p>
        <p>8. 线程池的基本使用</p>
        <p>9. MongoDB基本使用</p>
        <p>10. Redis应用与原理</p>
        <p>11. 搜索引擎-ElasticSearch</p>
        <p>12. 消息中间件-RabbitMQ、RocketMQ</p>
        <p>13. ELK日志平台的应用</p>
        <p>14. 数据结构与算法（上）</p>
        <p>15. 数据结构与算法（下）</p>
        <p>16. 容器化技术概览</p>
      </div>

      <div class="tag">具备市场价值</div>
      <div class="subject-block ability">
        <p>
          <span></span>
          熟悉常用的Java生态圈技术，为后续架构课学习打下基础；
        </p>

        <p>
          <span></span>
          具备软件体系的横向总结能力，不再停留在散列的一个个技术点上；
        </p>

        <p>
          <span></span>
          逐渐适应狂野架构师的学习方式，认识并接触必修课中的老师们，为后续的学习铺好路，具备基本的技术知识，迈向架构师的征程即将打开……
        </p>
      </div>
    </div>

    <div class="btn" @click="openDetail">了解更多课程内容</div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop" v-if="show">
        <div class="block-tops">
          <div class="title">{{ list[cur].title }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="tag tag2">主要内容</div>

        <div
          class="target"
          v-for="(item1, index1) in list[cur].primaryCoverage"
          :key="index1 + 'a'"
        >
          <div class="block-title">{{ item1.itemTit }}</div>
          <p v-for="i in item1.itemArr" :key="i">
            <span></span>
            {{ i }}
          </p>
        </div>

        <div class="tag tag2">核心能力培养</div>
        <div class="target">
          <p v-for="j in list[cur].corCompetence" :key="j">{{ j }}</p>
        </div>

        <div class="tag tag2">具备市场价值</div>
        <div class="target">
          <p v-for="k in list[cur].marketValue" :key="k">{{ k }}</p>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showBlock" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">2年~4年经验学习起点</div>
          <div class="close" @click="showBlock = false"></div>
        </div>

        <div class="tag tag2">学习背景</div>

        <div class="target">
          <p>
            从事Java开发2-4年，已初步学会使用项目中的Java技术栈、开发流程，了解常用中间件。这个年限的小伙伴如果要晋级架构师，要确保在开发层面对知识体系查缺补漏，达到熟练运用常见开发框架、中间件完成基本的项目搭建和开发，需要将常用的技术做一个全局的盘点，关注相互之间的联系，并学会跳出技术点本身，站在全局视角来看待其相关的整个体系。
          </p>
        </div>

        <div class="tag tag2">
          主要内容
          <span>（部分课程穿插直播）</span>
        </div>
        <div class="target">
          <p>1. 微服务-SpringBoot快速开发</p>
          <p>2. 开发阵营之一：Dubbo体系基础</p>
          <p>3. 分布式协调工具：Zookeeper深度剖析</p>
          <p>4. 开发阵营之二：SpringCloud体系基础</p>
          <p>5. 链路追踪工具：Skywalking真实演练</p>
          <p>6. 发布工具：携程Apollo应用发布实战</p>
          <p>7. 网络编程基础</p>
          <p>8. 线程池的基本使用</p>
          <p>9. MongoDB基本使用</p>
          <p>10. Redis应用与原理</p>
          <p>11. 搜索引擎-ElasticSearch</p>
          <p>12. 消息中间件-RabbitMQ、RocketMQ</p>
          <p>13. ELK日志平台的应用</p>
          <p>14. 数据结构与算法（上）</p>
          <p>15. 数据结构与算法（下）</p>
          <p>16. 容器化技术概览</p>
        </div>

        <div class="tag tag2">具备市场价值</div>
        <div class="target">
          <p class="block-p">
            <span></span>
            熟悉常用的Java生态圈技术，为后续架构课学习打下基础；
          </p>

          <p class="block-p">
            <span></span>
            具备软件体系的横向总结能力，不再停留在散列的一个个技术点上；
          </p>

          <p class="block-p">
            <span></span>
            逐渐适应狂野架构师的学习方式，认识并接触必修课中的老师们，为后续的学习铺好路，具备基本的技术知识，迈向架构师的征程即将打开……
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import check from "../../../utils/check";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    pageTitle,
  },
  mounted() {},
  data() {
    let that = this;
    return {
      list: [
        {
          nav: "阶段一",
          title: "阶段一   架构师起步",
          primaryCoverage: [
            {
              itemTit: "RPC体系",
              itemArr: [
                "RPC通信原理实战",
                "Netty通信技术进阶",
                "纯手写RPC",
                "Dubbo核心源码剖析",
              ],
            },
            {
              itemTit: "微服务体系",
              itemArr: [
                "Spring Cloud Netflix技术栈",
                "Spring Cloud 经典组件及原理",
                "Alibaba体系下的微服务解决方案",
              ],
            },
          ],

          corCompetence: [
            "Dubbo开发框架底层原理；",
            "分布式系统架构体系；",
            "Netty底层网络通讯；",
            "Spring Cloud构建微服务体系；",
            "Alibaba下的微服务解决方案。",
          ],
          marketValue: [
            "从日常熟悉的开发层两大主流框架体系入手，由浅入深，逐渐从使用到了解原理，开启架构师的学习节奏。",
          ],
        },
        {
          nav: "阶段二",
          title: "阶段二   架构师进阶",
          primaryCoverage: [
            {
              itemTit: "海量数据",
              itemArr: [
                "Redis - 高性能缓存代理方案实战",
                "分布式检索引擎ElasticSearch",
                "MongoDB打造无限用户增量数据动态扩容机制",
                "TiDB海量数据下的灵活扩容方案",
              ],
            },
            {
              itemTit: "超高并发",
              itemArr: [
                "软负载均衡器 LVS+Keepalived 高可用部署实战",
                "Openresty - 超高用户访问流量拦截控制处理",
              ],
            },
            {
              itemTit: "异步解耦",
              itemArr: [
                "Kafka - 海量数据同步落地方案",
                "RocketMQ- 业务场景下消息队列的最优处理方案",
                "RabbitMQ - 消息系统界的经典代表作",
              ],
            },
          ],
          corCompetence: [
            "掌握各种各样的大规模数据存储；",
            "Redis、搜索引擎、NoSQL、NewSQL的深度应用；",
            "掌握LVS、Keepalived、OpenResty的深度使用；",
            "具备打造超高并发，大数据量场景下的应对能力。",
          ],
          marketValue: [
            "本阶段进入架构师的进阶期，全面掌握各种各样的数据存储，具备掌控项目中底层存储的设计能力，同时本小节将带你走进超高并发场景下的负载均衡，以及如何打造高可用的软件系统。",
          ],
        },
        {
          nav: "阶段三",
          title: "阶段三  架构师深入",
          primaryCoverage: [
            {
              itemTit: "源码剖析",
              itemArr: [
                "Tomcat源码剖析",
                "Spring 源码深度剖析",
                "SpringBoot源码剖析",
                "MyBatis 源码剖析",
                "JDK源码剖析",
              ],
            },
            {
              itemTit: "性能优化",
              itemArr: [
                "高性能队列Disruptor",
                "并发编程调优",
                "JVM调优",
                "MySQL数据库调优",
                "MySQL生产环境扩容实战",
                "全链路压测",
              ],
            },
          ],
          corCompetence: [
            "掌握主流的开源项目源码；",
            "熟知源码中的设计模式和设计思想；",
            "关注性能，具备从各个层面进行系统性能分析和调优的能力。",
          ],
          marketValue: [
            "架构师不但要学会日常框架的使用，还需要深入其源码和设计思想层面，知其所以然。同时，对系统各个层面的调优工作，也是架构师优于一般开发的技能。",
          ],
        },
        {
          nav: "阶段四",
          title: "阶段四  云原生",
          primaryCoverage: [
            {
              itemTit: "Linux必备基本功",
              itemArr: [
                "sed",
                "vim",
                "less",
                "more",
                "crontab",
                "Linux相关体系",
              ],
            },

            {
              itemTit: "容器化技术 Docker",
              itemArr: [
                "Dockerfile开启Docker镜像的大门",
                "远程获取镜像与自己打镜像",
                "Docker的文件存储体系",
                "Docker数据迁移",
                "Linux虚拟网络技术演练",
                "彻底理解Docker的四种网络模型",
                "Docker跨主机通信的四大方案原理",
                "镜像仓库 - 镜像的聚集地",
                "registry与harbor的搭建与使用",
                "compose本地编排的利器",
                "跨机器Docker容器集群调度之swarm",
                "大规模微服务Docker持续集成综合演练",
              ],
            },

            {
              itemTit: "容器编排 Kubernetes",
              itemArr: [
                "Kubernetes基础回顾",
                "Kubernetes架构与背后的设计思想",
                "Kubernetes各式各样的组件详谈",
                "线上服务如何滚动升级",
                "K8S容器服务如何回滚",
                "互联网常用的ingress-Nginx如何实现灰度发布",
                "K8S ingress-Nginx如何实现header流量切分",
                "K8S ingress-Nginx如何实现Cookie流量切分K8S ",
                "ingress-Nginx如何实现Weight流量切分",
              ],
            },

            {
              itemTit: "服务网格 Service Mesh",
              itemArr: [
                "Service Mesh简介",
                "Istio是什么？",
                "Istio快速入门",
                "Istio进阶",
                "BookInfo示例分析",
                "Istio实战",
              ],
            },
          ],

          corCompetence: [
            "掌握Linux的一些高频操作；",
            "对公有云可提供的可用服务有所了解；",
            "掌握容器化技术Docker；",
            "掌握大规模Docker容器的编排；",
            "掌握云原生、服务网格、ServiceMesh。",
          ],
          marketValue: [
            "微服务化的大趋势下，云是必备的部署环境，作为架构师，必须要掌握容器化的解决方案、大规模的编排工具以及线上公有云可提供的服务。学习本章节，你将深度把握微服务云原生相关的技术体系。",
          ],
        },
        {
          nav: "阶段五",
          title: "阶段五  架构师百宝箱",
          primaryCoverage: [
            {
              tag: 1,
              itemTit: "持续集成 Jenkins",
              itemArr: [
                "Jenkins原理剖析",
                "Jenkins插件安装",
                "Jenkins脚本编写",
                "Jenkins持续集成",
                "Jenkins自动化部署实战",
              ],
            },
            {
              tag: 1,
              itemTit: "版本管理工具Git",
              itemArr: ["Git命令", "库", "分支管理", "冲突解决", "高级应用"],
            },
            {
              tag: 1,
              itemTit: "Ant到Maven看项目构建工具演进",
              itemArr: [
                "Ant的简介及历史",
                "Maven诞生及优点",
                "Maven常用插件",
                "Nexus仓库",
              ],
            },
            {
              tag: 1,
              itemTit: "阿里 Arthas",
              itemArr: ["调试", "监控"],
            },
            {
              tag: 1,
              itemTit: "Groovy语言及应用",
              itemArr: ["Commons", "Guava"],
            },
            {
              tag: 1,
              itemTit: "定时任务工具",
              itemArr: ["Crontab", "Spring Cron", "ElasticJob", "XXL-Job"],
            },
            {
              tag: 1,
              itemTit: "Zabbix服务器监控工具",
              itemArr: ["Zabbix的配置与使用", "监控与预警"],
            },
            {
              tag: 1,
              itemTit: "测试工具",
              itemArr: ["单元测试", "Jmeter压测", "Junit高级应用"],
            },
          ],
          corCompetence: [
            "熟练掌握Git的⾼级应⽤；",
            "了解项⽬构建⼯具的历史；",
            "掌握Maven的⾼级应⽤；",
            "熟练运⽤Arthas到⽇常开发⼯作中；",
            "掌握Jenkins持续集成⼯具；",
            "熟练运⽤Groovy语⾔，提升⽇常场景⼯作效率；",
            "掌握常⽤第三⽅类库、定时任务⼯具；",
            "熟练运⽤定时任务⼯具完成定时场景下的软件设计；",
            "能够重视测试⼯具的使⽤，完成单元测试压测等⽬标。",
          ],
          marketValue: [
            "⼯欲善其事必先利其器，掌握⽇常⼯具的使⽤是架构师提升效率的重要⼿段。学习该篇章可以查缺补漏，提升技能，让你在软件架构与⽇常设计中，有N多件“趁⼿的家伙”。",
          ],
        },
        {
          nav: "阶段六",
          title: "阶段六  架构设计",
          primaryCoverage: [
            {
              tag: 1,
              itemTit: "软件架构设计攻略",
              itemArr: [
                "项目设计理念",
                "链式编程思想",
                "响应式编程思想",
                "问题的解决思路",
                "函数式编程",
                "技术选型",
              ],
            },
            {
              tag: 1,
              itemTit: "设计模式及其思想",
              itemArr: [
                "从架构层面看设计模式",
                "软件设计原则",
                "常见设计模式剖析",
                "深入剖析Spring中的设计模式",
                "架构设计中的设计模式解析",
              ],
            },
            {
              tag: 1,
              itemTit: "阿里系代码规范及应用",
              itemArr: ["Sonar", "阿里开发规范", "规约插件", "技术文档"],
            },
            {
              tag: 1,
              itemTit: "应用级算法思想",
              itemArr: [
                "一致性Hash",
                "加密",
                "调度",
                "限流",
                "定时",
                "负载均衡",
              ],
            },
            {
              tag: 1,
              itemTit: "敏捷宣言",
              itemArr: ["软件管理之道", "项目管理发展", "敏捷理念", "敏捷工具"],
            },
          ],
          corCompetence: [
            "能够在⽇常项⽬中运⽤熟悉的设计模式；",
            "熟练掌握UML⼯具，能够完成建模操作；",
            "具备⽇常架构师设计思维，找到解决问题的办法；",
            "熟悉⽇常代码规范⼯具，了解、参考阿⾥代码规范；",
            "理解⽇常的软件应⽤级算法；",
            "掌握敏捷开发思想，能够应⽤于项⽬开发中。",
          ],
          marketValue: [
            "通过设计模式的学习，将系统代码结构升华到⾼层次⽔平。掌握UML可以让你的软件设计事半功倍。以业界推崇的阿⾥系代码规范为本，培养良好的编码习惯，深⼊理解软件架构设计思想，以及敏捷的项⽬管理经验，提升架构师全局把控项⽬的能⼒。",
          ],
        },
        {
          nav: "阶段七",
          title: "阶段七  项目实战",
          primaryCoverage: [
            {
              tag: 1,
              itemTit: "",
              itemArr: [
                "打车项目架构深度剖析",
                "实名认证接入",
                "车主认证海量文件存储",
                "OpenCV机器视觉技术",
                "OCR自动化车主认证系统",
                "司机行程发布",
                "乘客智能打车",
                "打车高峰高并发处理",
                "顺风车即时通信及时配单",
                "微信/支付宝支付",
                "平台数据大屏监控",
              ],
            },
          ],

          corCompetence: [
            "掌握项⽬设计的架构师思维与流程；",
            "掌握实名认证领域的相关知识；",
            "掌握⽹站分布式⽂件存储设计；",
            "熟悉OpenCV在Java图像处理领域的应⽤；",
            "掌握Redis GEO在距离计算上的应⽤；",
            "熟练运⽤Redis结构设计，完成打⻋⾏程的智能匹配；",
            "掌握基于WebSocket的⽹⻚即时通讯设计；",
            "掌握⽀付系统的接⼊流程；",
            "学会使⽤多渠道数据采集，完成数据⼤屏的展示。",
          ],
          marketValue: [
            "通过项⽬⽅式，将架构师课程中所学习的基本技术落地，从⽽具备实战功底，远离纸上谈兵的PPT架构。",
          ],
        },
        {
          nav: "阶段八",
          title: "阶段八  DevOps实战",
          primaryCoverage: [
            {
              tag: 1,
              itemTit: "",
              itemArr: [
                "Docker+K8S云环境搭建",
                "KubeSphere简介与应用",
                "KubeSphere一站式部署",
                "DevOps自动化部署",
                "微服务上云全程剖析",
                "顺风车上云架构实战",
              ],
            },
          ],
          corCompetence: [
            "掌握基本的Docker+K8S环境搭建；",
            "掌握KubeSphere企业云环境的安装与使用；",
            "学会DevOps自动化运维的常用技术栈；",
            "掌握微服务网站架构上云的技术手段；",
            "学会从0到1实现微服务项目的上云。",
          ],
          marketValue: [
            "架构师不但要掌握开发层的技术手段，在云计算流行的大环境下，对自动化运维、服务上云等层面的技术要求同样重要，通过本篇章学习，可以让你轻松实现企业项目在云服务上的全程自动化运维。",
          ],
        },
      ],
      cur: 0,
      show: false,
      showBlock: false,
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box8",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;

            document.getElementsByClassName("nav-box")[0].scrollLeft =
              this.realIndex * 80;
          },
          click(e) {
            if (
              e.target.className == "open" ||
              (that.$refs.block &&
                e.target.className !=
                  "swiperwrap swiper-slide swiper-slide-active")
            ) {
              that.show = true;
            }
            if (
              e.target.className == "play" ||
              e.target.className == "play-btn"
            ) {
              that.showVideo = true;
              that.src = that.subject[that.cur].video;
              let dom = document.getElementsByTagName("video");
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.zixun("查看详细大纲");
      }
    },
     zixun(name) {
      zhuge.track("H5_狂野架构师专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
    changeCur(index) {
      this.swiper.slideTo(index, 500, false);
      this.cur = index;
    },
    open() {
      this.showBlock = true;
    },
   
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 0px 0px 88px;
  width: 100%;
  background-color: #eef5ff;
  overflow: hidden;
  .van-popup {
    padding-bottom: 24px;
    max-height: calc(100% - 80px);
    box-sizing: border-box;
  }
  .title {
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    font-weight: bold;
    line-height: 62px;
    text-align: center;
    letter-spacing: 0px;
    color: #24375c;
    p {
      margin-top: 7px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #24375c;
    }
  }
  .three {
    background: url("../../../assets/coursePage/architect/box6new/title3.png");
    width: 356px;
    height: 48px;
    background-size: cover;
    margin: 50px auto 30px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #ffffff;
    text-align: center;
  }
  .subTitle {
    font-family: PingFangSC-Semibold;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #24375c;
    text-align: center;
    margin-bottom: 48px;
  }
  .pop-title {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: space-between;
    padding: 40px 0px;
    width: 610px;
    background: #fff;
    box-sizing: border-box;
    z-index: 50;
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
  }

  .tit {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0 auto;
    width: 670px;
    height: 97px;
    background: url("../../../assets/coursePage/architect/box6/title.png")
      no-repeat;
    background-size: cover;
    box-shadow: 0px 6px 24px 0px #dbefff;
    font-family: PingFang SC;
    font-size: 26px;
    text-align: center;
    font-weight: normal;
    letter-spacing: 0px;

    color: #ffffff;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #ffffff;
    }
    &::after {
      content: "5年经验";
      position: absolute;
      left: 0px;
      top: -16px;
      width: 146px;
      height: 43px;
      background-color: #56baff;
      border-radius: 12px;
      justify-content: center;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      display: flex;
      align-items: center;
      letter-spacing: 0px;
      color: #ffffff;
    }
  }

  .tit1 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 40px;
    width: 670px;
    height: 97px;
    background: url("../../../assets/coursePage/architect/box6/title.png")
      no-repeat;
    background-size: cover;
    box-shadow: 0px 6px 24px 0px #dbefff;
    font-family: PingFang SC;
    font-size: 26px;
    text-align: center;
    font-weight: normal;
    letter-spacing: 0px;

    color: #ffffff;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #ffffff;
    }
    &::after {
      content: "2～4年经验";
      position: absolute;
      left: 0px;
      top: -16px;
      width: 146px;
      height: 43px;
      background-color: #56baff;
      border-radius: 12px;
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .scorll-box6 {
    overflow-x: scroll;
    .nav-box::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }
  }
  .nav-box {
    display: flex;
    justify-content: space-between;
    margin: 48px 0 0px;
    position: relative;
    font-family: PingFang SC;
    font-size: 24px;
    font-weight: 400;
    color: #1d2129;
    display: flex;
    justify-content: space-between;
    overflow-x: scroll;
    transition: all 0.2s;
    padding: 0 32px 0 32px;
    .nav {
      width: 138px;
      height: 68px;
      background: #ffffff;
      border-radius: 8px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 68px;
      text-align: center;
      margin-right: 20px;
      flex-shrink: 0;
    }

    .cur-nav {
      background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);

      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;

      position: relative;
    }
  }

  .content {
    position: relative;
    margin: 48px auto 0;
    padding: 40px;
    width: 690px;
    height: 700px;
    background: url("../../../assets/coursePage/architect/box6/box.png")
      no-repeat;
    background-size: cover;
    box-shadow: 0px 6px 24px 0px #dbefff;
    border-radius: 20px;
    box-sizing: border-box;
    overflow: hidden;

    .open {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 30px;
      width: 100%;
      height: 140px;
      // background: #fff;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 40%,
        #fff 100%
      );
      border-radius: 0px 0px 20px 20px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      box-sizing: border-box;
      z-index: 40;

      img {
        margin-left: 8px;
        width: 32px;
        height: 32px;
      }
    }
  }

  .pop {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      padding: 0 24px;
      width: max-content;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2674ff;
      line-height: 56px;
    }
    .tag2 {
      margin-bottom: 24px;
    }
    .target {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
      .block-title {
        color: rgb(51, 51, 51);
        font-size: 26px;
        margin-bottom: 8px;
        font-family: PingFangSC-Medium;
      }
      p.indent {
        display: inline-block;
        text-align: justify;
        text-indent: -32px;
        padding-left: 40px;
      }
      p.indent:nth-child(9) ~ p.indent {
        text-indent: -43px;
        padding-left: 43px;
      }
    }
  }

  .stage {
    margin-bottom: 40px;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #006aff;
  }

  .tag {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 44px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
      background-size: contain;
    }
  }

  .subject-block {
    margin-bottom: 48px;
    .block-title {
      color: rgb(51, 51, 51);

      font-size: 26px;
      margin-bottom: 8px;
      font-family: PingFangSC-Medium;
      margin-left: 45px;
    }
    p {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-left: 45px;
      i {
        display: none;
        width: 4px;
        height: 4px;
        background: #87d4bd;
        border-radius: 2px;
        margin-right: 16px;
      }
    }
  }
  .ability {
    p {
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 85px;
  	background-image: linear-gradient(0deg, 
		#ff4d24 0%, 
		#ff5e29 100%);
	border-radius: 44px;

    font-family: PingFangSC-Semibold;
    font-size: 30px;
    text-align: center;
    line-height: 85px;
    letter-spacing: 2px;
color: #fff6e5;
  }
  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2674ff;
      line-height: 56px;
      padding: 0 24px;
    }
    .tag2 {
      width: max-content;
      margin-bottom: 24px;
    }
    .target {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;

      p.indent {
        display: inline-block;
        text-align: justify;
        text-indent: -32px;
        padding-left: 40px;
      }
      p.indent:nth-child(9) ~ p.indent {
        text-indent: -43px;
        padding-left: 43px;
      }
    }
  }
}
</style>
